import React from 'react';
import { Modal as AntdModal } from 'antd';
import styled from 'styled-components';
import type { ModalProps } from 'antd/es/modal';
import { antdModal, useModal } from '@ebay/nice-modal-react';

const Modal = styled(AntdModal)`
  color: ${(props) => props.theme.colors.primary};
  border-radius: 10px;
  overflow: hidden;
  margin-top: 20px;
  margin-bottom: 20px;

  .ant-modal-close {
    border: 1px solid white;
    width: 30px;
    height: 30px;

    svg {
      fill: white;
    }
  }

  .ant-modal-content {
    padding: 0;
    border-radius: 0;
    border-bottom: 30px solid ${(props) => props.theme.colors.primary};
  }

  .ant-modal-header {
    padding: 20px 30px;
    background-color: ${(props) => props.theme.colors.primary};
    font-size: 1rem;
    border-radius: 0;
    min-height: 60px;

    .ant-modal-title {
      color: white;
      font-size: 1.5rem;
      text-transform: uppercase;
    }
    @media (max-width: 640px) {
      .ant-modal-title {
        font-size: 1.2rem;
      }
    }
  }

  .ant-modal-footer {
    padding: 15px 30px;
    border-top: 5px solid ${(props) => props.theme.colors.primary};
  }
`;

const StyledModal: React.FC<ModalProps> = ({
  title,
  centered,
  closable = true,
  ...props
}) => {
  const modal = useModal();
  return (
    <Modal
      {...antdModal(modal)}
      {...props}
      title={title || ' '}
      closable={closable}
      centered={centered || true}
      maskClosable={false}
    />
  );
};

export default StyledModal;
